import { render, staticRenderFns } from "./product-category.vue?vue&type=template&id=55bf9d02&scoped=true&"
import script from "./product-category.vue?vue&type=script&lang=js&"
export * from "./product-category.vue?vue&type=script&lang=js&"
import style0 from "./product-category.vue?vue&type=style&index=0&id=55bf9d02&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bf9d02",
  null
  
)

export default component.exports